import { useT } from '@/i18n'
import { commonMessages } from '@/i18n/messages/common'

/** Quiet maker credit. Company names stay as they are in every language. */
export function MadeBy({ className }: { className?: string }) {
  const t = useT(commonMessages)
  return <p className={className}>{t('madeBy')}</p>
}
